// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCKE2aj-A4EZRb9GYX80W8OXM50CAHAFaI',
    authDomain: 'covid-innovation-221486.firebaseapp.com',
    databaseURL: 'https://covid-innovation-221486.firebaseio.com',
    projectId: 'covid-innovation-221486',
    storageBucket: 'covid-innovation-221486.appspot.com',
    messagingSenderId: '717695226726',
    appId: '1:717695226726:web:53a901fa7b2533569ceea7',
    measurementId: 'G-K5KKNZBC7H',
    tagManagerId: 'GTM-5VWN3FG'
  },
  app: {
    version: '0.10.1',
    mapKey: 'AIzaSyDUQYbsghMsV3gWOn6ENZkfeTxr1bN5EP4',
    functionsUrl: 'https://us-central1-covid-innovation-221486.cloudfunctions.net',
    cdnUrl: 'https://storage.cloud.google.com/covid-innovation-221486.appspot.com',
    elasticSearchUrl: 'https://f5c0b9ae2c1c490785602651185f024b.app-search.us-central1.gcp.cloud.es.io/api/as/v1/engines',
    elasticProductEngine: 'retriever-v3',
    elasticStoreEngine: 'retriever-store',
    elasticSearchKey: 'search-f821v1j46mypbq82xpovuhtv',
    host: 'https://covid-innovation-221486.web.app',
    barcodeKey: 'ma6z1m4502isjj9g0oz1tf81mdat7k'
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
